var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{attrs:{"title":'Edit Pendaftaran atau Perjanjian'},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Form',{attrs:{"initial-form":_vm.form,"route":'appointments/' + _vm.form.id,"purpose":'edit'}})]},proxy:true}])})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }